// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"z3-z","displaySixCardTiles":"A3-z"};